<mat-card class="individual-create-view">
    <mat-card-title>New individual</mat-card-title>
    <mat-stepper linear #stepper>
        <mat-step [stepControl]="individualDetailsForm">
            <ng-template matStepLabel>Individual details</ng-template>
            <form class="mt-4" [formGroup]="individualDetailsForm" (ngSubmit)="save()">
                <div class="row">
                    <div class="col-md-6">
                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Title</mat-label>
                                <mat-select required data-testid="individual-title" formControlName="title">
                                    <mat-option value="Mr">Mr</mat-option>
                                    <mat-option value="Mrs">Mrs</mat-option>
                                    <mat-option value="Miss">Miss</mat-option>
                                    <mat-option value="Prof">Prof</mat-option>
                                    <mat-option value="Dr">Dr</mat-option>
                                </mat-select>
                                <mat-error *ngIf="individualDetailsForm.get('title')?.invalid">
                                    Title is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Initials</mat-label>
                                <input required data-testid="individual-initials" formControlName="initials" matInput
                                    placeholder="Initials">
                                <mat-error *ngIf="individualDetailsForm.get('initials')?.invalid">
                                    Initials are invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>First name</mat-label>
                                <input required data-testid="individual-first-name" formControlName="firstName" matInput
                                    placeholder="First name">
                                <mat-error *ngIf="individualDetailsForm.get('firstName')?.invalid">
                                    First name is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Surname</mat-label>
                                <input required data-testid="individual-last-name" formControlName="lastName" matInput
                                    placeholder="Surname">
                                <mat-error *ngIf="individualDetailsForm.get('lastName')?.invalid">
                                    Surname is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Gender</mat-label>
                                <mat-select required data-testid="individual-gender" formControlName="gender">
                                    <mat-option value="male">Male</mat-option>
                                    <mat-option value="female">Female</mat-option>
                                    <mat-option value="other">Other</mat-option>
                                </mat-select>
                                <mat-error *ngIf="individualDetailsForm.get('gender')?.invalid">
                                    Gender is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Is this an animal?</mat-label>
                                <mat-select required formControlName="isAnimal">
                                    <mat-option value="0">No</mat-option>
                                    <mat-option value="1">Yes</mat-option>
                                </mat-select>
                                <mat-error *ngIf="individualDetailsForm.get('isAnimal')?.invalid">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Phone Number</mat-label>
                                <input required data-testid="individual-phone-number" formControlName="phoneNumber"
                                    matInput placeholder="Phone Number">
                                <mat-error *ngIf="individualDetailsForm.get('phoneNumber')?.invalid">
                                    Phone Number is required
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>
                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Alternative phone number</mat-label>
                                <input formControlName="phoneNumberAlt" matInput placeholder="Phone Number">
                                <mat-error *ngIf="individualDetailsForm.get('phoneNumberAlt')?.invalid">
                                    Alternative phone number is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Email address</mat-label>
                                <input required data-testid="individual-email" formControlName="email" matInput
                                    placeholder="Email address">
                                <mat-error *ngIf="individualDetailsForm.get('email')?.invalid">
                                    Email address is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Alternative email address</mat-label>
                                <input data-testid="individual-alt-email" formControlName="emailAlt" matInput
                                    placeholder="Email address">
                                <mat-error *ngIf="individualDetailsForm.get('emailAlt')?.invalid">
                                    Alternative email address is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>


                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Date of birth</mat-label>
                                <input required data-testid="individual-date-of-birth" formControlName="dateOfBirth"
                                    matInput [matDatepicker]="picker1">
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                                <mat-error *ngIf="individualDetailsForm.get('date')?.invalid">
                                    Date of birth is required
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Individual type</mat-label>
                                <mat-select required data-testid="individual-type" #chosenValue
                                    formControlName="individualType">
                                    <mat-option *ngFor="let type of individualTypes" [value]="type.id">
                                        {{type.type}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="individualDetailsForm.get('individualType')?.invalid">
                                    Choose from provided options
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Number Of dependants</mat-label>
                                <input data-testid="individual-number-of-dependants" type="number" min="0"
                                    formControlName="numberOfDependants" matInput placeholder="Number of Dependants">
                                <mat-error *ngIf="individualDetailsForm.get('numberOfDependants')?.invalid">
                                    Number of dependants is required
                                </mat-error>
                            </mat-form-field>
                        </p>
                    </div>
                </div>
            </form>

            <div class="my-2">

                <button *ngIf="!selectedCompany" (click)="openSearchCompanyDialog()" mat-stroked-button>
                    Select company
                </button>

                <button *ngIf="selectedCompany" (click)="deselectCompany()" mat-stroked-button>
                    <mat-icon>cancel</mat-icon> Remove
                </button>
                <div class="details" *ngIf="selectedCompany">
                    <div class="py-2">
                        <mat-divider></mat-divider>
                    </div>
                    <table class="mt-4">
                        <tr>
                            <th>
                                Name
                            </th>
                            <td>
                                {{ selectedCompany.name ? selectedCompany.name : "-" }}
                            </td>
                        </tr>

                        <tr>
                            <th>
                                Alternative email address
                            </th>
                            <td>
                                {{
                                selectedCompany.email_alt ? selectedCompany.email_alt :
                                "-"
                                }}
                            </td>
                        </tr>

                        <tr>
                            <th>
                                Phone number
                            </th>
                            <td>
                                {{
                                selectedCompany.phone_number ?
                                selectedCompany.phone_number :"-"
                                }}
                            </td>
                        </tr>

                        <tr>
                            <th>
                                Email
                            </th>
                            <td>
                                {{ selectedCompany.email ? selectedCompany.email : "-"
                                }}
                            </td>
                        </tr>

                        <tr>
                            <th>
                                Alternative phone number
                            </th>
                            <td>
                                {{ selectedCompany.phone_number_alt ?
                                selectedCompany.phone_number_alt : "-" }}
                            </td>
                        </tr>

                        <tr>
                            <th>
                                Practice number
                            </th>
                            <td>
                                {{ selectedCompany.practice_number ?
                                selectedCompany.practice_number : "-" }}
                            </td>
                        </tr>

                        <tr>
                            <th>
                                VAT registration number
                            </th>
                            <td>
                                {{ selectedCompany.vat_registration_number ?
                                selectedCompany.vat_registration_number : "-" }}
                            </td>
                        </tr>

                    </table>
                </div>
            </div>

            <div class="my-2">
                <div class="py-2 mt-4">
                    <mat-divider></mat-divider>
                </div>
                <h3 mat-card-subtitle>Distributor</h3>
                <p>
                    <button type="button" *ngIf="!selectedDistributor" mat-stroked-button (click)="openSearchDistributorDialog()">
                        Select distributor
                    </button>
                </p>
                <div *ngIf="selectedDistributor" class="details mt-2">
                    <button type="button" mat-stroked-button (click)="deselectDistributor()" class="me-2 my-2">
                        <mat-icon>cancel</mat-icon> Remove
                    </button>
                    <table class="mt-4">
                        <tr>
                            <th>Name</th>
                            <td>{{ selectedDistributor.name ? selectedDistributor.name : "-" }}</td>
                        </tr>
                        <tr>
                            <th>Email</th>
                            <td>{{ selectedDistributor.email ? selectedDistributor.email : "-" }}</td>
                        </tr>
                        <tr>
                            <th>Phone number</th>
                            <td>{{ selectedDistributor.phone_number ? selectedDistributor.phone_number : "-" }}</td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="text-end">
                <button data-testid="next-step" [disabled]="!individualDetailsForm.valid || !selectedDistributor" class="mx-1" color="primary"
                    mat-raised-button matStepperNext>
                    <mat-icon>chevron_right</mat-icon> Next
                </button>
            </div>
        </mat-step>
        <mat-step [stepControl]="addressDetailsForm">
            <ng-template matStepLabel>Address details</ng-template>
            <form [formGroup]="addressDetailsForm">

                <div class="row">
                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Search for a country</mat-label>
                                <input required [disabled]="isLoading" type="text" placeholder="Search for a country"
                                    aria-label="Search for a country" matInput formControlName="country"
                                    [matAutocomplete]="auto">
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                    <mat-option *ngFor="let country of filteredCountriesForIndividual | async"
                                        [value]="country.name">
                                        {{country.name}}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-icon matPrefix>search</mat-icon>
                                <mat-error *ngIf="individualDetailsForm.get('country')?.invalid">
                                    Country is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Province</mat-label>
                                <mat-select required data-testid="individual-province" formControlName="province">
                                    <mat-option *ngFor="let province of provinces" value="{{province.name}}">
                                        {{province.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="individualDetailsForm.get('province')?.invalid">
                                    Province is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>City</mat-label>
                                <input type="text" formControlName="city" matInput />
                                <mat-error *ngIf="addressDetailsForm.get('city')?.invalid">
                                    City is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Address line 1</mat-label>
                                <input required data-testid="individual-address-line-1" formControlName="addressLine1"
                                    matInput placeholder="Address Line 1">
                                <mat-error *ngIf="individualDetailsForm.get('addressLine1')?.invalid">
                                    Address Line 1 is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>

                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Suburb</mat-label>
                                <input data-testid="individual-address-line-2" formControlName="addressLine2" matInput
                                    placeholder="Suburb">
                                <mat-error *ngIf="individualDetailsForm.get('addressLine2')?.invalid">
                                    Suburb is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Building number</mat-label>
                                <input required data-testid="individual-building-apt-number"
                                    formControlName="buildingAptNumber" type="number" min="1" matInput
                                    placeholder="Building Number">
                                <mat-error *ngIf="individualDetailsForm.get('buildingAptNumber')?.invalid">
                                    Building number is required
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Postcode</mat-label>
                                <input required data-testid="individual-postcode" formControlName="postcode" matInput
                                    placeholder="Postcode">
                                <mat-error *ngIf="individualDetailsForm.get('postcode')?.invalid">
                                    Postcode is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>
                </div>

            </form>

            <div class="text-end">

                <button class="mx-1" data-testid="previoous-step" color="primary" mat-raised-button matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon> Back
                </button>

                <button data-testid="next-step" (click)="save()"
                    [disabled]="!individualDetailsForm.valid || !addressDetailsForm.valid || !selectedDistributor || isLoading" class="mx-1"
                    color="primary" mat-raised-button>
                    <mat-icon>save</mat-icon> Save
                </button>
            </div>
        </mat-step>
    </mat-stepper>
</mat-card>